import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core';

import * as Icons from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

for(var icon in Icons) {
  if(typeof(Icons[icon]) == 'object') {
    library.add(Icons[icon]);
  }
}

Vue.component('font-awesome-icon', FontAwesomeIcon);

export default Icons